@for (message of messages; track message) {
  <div class="panel-body mb-l">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-2">
        <div class="text-center my-auto">
          <mat-icon class="exclamation">error</mat-icon>
        </div>
      </div>
      <div class="col-md-10">
        <div class="mat-card no-shadow {{message.type}}">
          <div class="notify">{{message.text}}</div>
        </div>
      </div>
    </div>
  </div>
}
